module.exports = __webpack_public_path__ + "static/media/yulong.3b7df778.png";